module.exports = __webpack_public_path__ + "static/media/kaocha.bd97efbc.jpg";